export const RefreshTokenSettings = () =>
  import('./RefreshTokenSettings').then(({ RefreshTokenSettings }) => {
    return {
      Component: RefreshTokenSettings
    };
  });
